import axios from 'axios';

// search messages api
export async function searchMessagesAPI(Data) {
	let messagelist = [];
	const messageName = Data === undefined ? '' : Data;

	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}system/messages/search/?messageName=${messageName}`,
			data: Data,
			headers: { 
				'content-type': 'application/json',
			}
		});
		  
		const { data } = response;
		messagelist = data;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return messagelist;
}

// check existing vat input api
export async function getMessagesCodeAPI(Data) {
	let messagelist = [];
	const messageCode = Data === undefined ? '' : Data;

	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}system/messages/getmessage/?messageCode=${messageCode}`,
			data: Data,
			headers: { 
				'content-type': 'application/json',
			}
		});
		  
		const { data } = response;
		messagelist = data;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return messagelist;
}

//create messages api
export async function createMessagesAPI(Data, userID) {
	let messageData = [];
	try{
		const axiosResponse = await axios({
			method: 'POST',
			url: `${process.env.REACT_APP_BACKEND_API}system/messages/create/`,
			data: {Data, userID}
		}).then(response => {
			return response;
		});
  
		// @ts-ignore
		messageData = axiosResponse;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return messageData;
}

//update message api
export async function updateMessagesAPI(Data, messageID, userID) {
	let messageData = [];
	try{
		const axiosResponse = await axios({
			method: 'PUT',
			url: `${process.env.REACT_APP_BACKEND_API}system/messages/update/?messageID=${messageID}&userID=${userID}`,
			data: Data
		}).then(response => {
			return response;
		});
  
		// @ts-ignore
		messageData = axiosResponse;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return messageData;
}